import React, { FC, useEffect, useState } from "react";
import facebookSvg from "images/Facebook.svg";
import twitterSvg from "images/Twitter.svg";
import googleSvg from "images/Google.svg";
import { Helmet } from "react-helmet-async";
import Input from "shared/Input/Input";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../config/firebase";
import { useMyContext } from "context/footerContext";

export interface PageLoginProps {
  className?: string;
}

const loginSocials = [
  {
    name: "Continue with Facebook",
    href: "#",
    icon: facebookSvg,
  },
  {
    name: "Continue with Twitter",
    href: "#",
    icon: twitterSvg,
  },
  {
    name: "Continue with Google",
    href: "#",
    icon: googleSvg,
  },
];

const PageLogin: FC<PageLoginProps> = ({ className = "" }) => {
  const { setValidFooter } = useMyContext();

  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loadingButton, setLoadingButton] = useState(false);
  const location = useLocation();

  const onLogin = (e: any) => {
    e.preventDefault();
    setLoadingButton(true);
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        navigate("/");
        console.log(user);
        setLoadingButton(false);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode, errorMessage);
        setLoadingButton(false);
      });
  };

  useEffect(() => {
    setValidFooter(location.pathname);

    return () => {
      setValidFooter("");
    };
  }, []);

  return (
    
<div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
  <Helmet>
    <title>Login</title>
  </Helmet>
  <div className="container mb-10 lg:mb-20 xl:mb-32">
    <div className="flex pb-10 justify-center shadow-[0_0_40px_-15px_rgba(0,0,0,0.3)] rounded-3xl w-full sm:w-[90%] md:w-[80%] lg:w-[670px] mx-auto px-4 sm:px-6 lg:px-8 mt-8 sm:mt-16 md:mt-24">
      <div className="w-full">
        <h2 className="my-8 sm:my-12 md:my-20 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-neutral-900 dark:text-neutral-100 text-center">
          Log in
        </h2>
        <div className="mx-auto space-y-6">
          {/* FORM */}
          <form
            className="grid grid-cols-1 gap-6"
            action="#"
            method="post"
            onSubmit={onLogin}
          >
            <label className="block mb-2">
              <span className="text-neutral-800 dark:text-neutral-200">
                Email
              </span>
              <Input
                id="email-address"
                type="email"
                placeholder="example@example.com"
                className="mt-1 h-12 sm:h-16 rounded-xl"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </label>
            <label className="block mb-2">
              <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                Password
              </span>
              <Input
                id="password"
                type="password"
                className="mt-1 h-12 sm:h-16 rounded-xl"
                placeholder="Your password"
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </label>
            <ButtonPrimary
              loading={loadingButton}
              className="bg-primary-111"
              type="submit"
            >
              Log in
            </ButtonPrimary>
          </form>

          <span className="block text-center text-neutral-700 dark:text-neutral-300">
            New user?{' '}
            <Link className="text-green-600" to="/start-register">
              Create an account
            </Link>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default PageLogin;
